export function getAllRaffleEntrants(raffles, id) {
  console.log(raffles, id);
  const val = {};
  [].concat
    .apply(
      [],
      raffles.map(({ slots }) => {
        return slots.map((i) => {
          return {
            slot_id: i.slot_id,
            raffle_winner: i.raffle_winner,
          };
        });
      })
    )
    .forEach(({ slot_id, raffle_winner: { player_id, player_name } }) => {
      val[id + slot_id] = {
        player_id: player_id,
        player_name: player_name,
      };
    });
  return val;
}

export function formatSlots(slots) {
  return Object.entries(slots)
    .map((slot: any) => {
      if (slot[1].player_id) {
        return {
          raffle_winner: {
            player_id: slot[1].player_id,
            player_name: slot[1].player_name,
          },
          slotcode: slot[0],
        };
      }

      return {
        raffle_winner: {
          player_id: "",
          player_name: "",
        },
        slotcode: slot[0],
      };
    })
    .filter((x) => !!x);
}
